import DataStructure, { sanitize } from "./DataStructure.js";
import { uid } from "quasar";
import { deepFreeze, formatCurrency } from "../util/misc.js";

export const CUSTOMER_QUOTE_MISC_ITEM_FIELDS = {
  id: "",
  itemType: "misc",
  line: 0,
  category: "",
  description: "",
  brand: "",
  price: null,
  notax: false,
};
deepFreeze(CUSTOMER_QUOTE_MISC_ITEM_FIELDS);

export default class CustomerQuoteMiscItem extends DataStructure {
  constructor(data = {}) {
    data = sanitize(data, CUSTOMER_QUOTE_MISC_ITEM_FIELDS);

    if (!data.id) {
      data.id = uid().slice(-12);
    }

    super(data);
  }

  // Editing

  get isValid() {
    return Boolean(this.data.description) && this.data.price >= 0;
  }

  // Formatting

  get price() {
    return this.data.price === null ? null : formatCurrency(this.data.price);
  }

  summary(length = 200) {
    const description = this.data.description.replace(
      /^\*\*+[^*]+\*\*+\s*/gm,
      ""
    );
    return length === null
      ? description
      : description.slice(0, length) + (description.length > length ? "…" : "");
  }

  toString() {
    return this.summary();
  }
}
